var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_bold_chevron_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1219 16.1405C17.8419 16.1405 17.5719 16.0305 17.3619 15.8205L12.0019 10.4605L6.64187 15.8205C6.22187 16.2405 5.53187 16.2405 5.11187 15.8205C4.69188 15.4005 4.69188 14.7105 5.11187 14.2905L11.2319 8.17047C11.6519 7.75047 12.3419 7.75047 12.7619 8.17047L18.8819 14.2905C19.3019 14.7105 19.3019 15.4005 18.8819 15.8205C18.6719 16.0305 18.3919 16.1405 18.1219 16.1405Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopButtonIcon);
export default __webpack_public_path__ + "static/media/top_button_icon.d23d01566f5f50886086d14902ec9639.svg";
export { ForwardRef as ReactComponent };